<template>
  <div>
    <table class="action-prop-table text-nowrap">
      <tr>
        <th>SKU</th>
        <td>{{ shortSKU }}</td>
      </tr>
    </table>

    <p v-if="isMGMOrderIdSpecified" class="mt-2">
      MY.GAMES market order id<br>
      {{ mgmOrderId }}
    </p>

    <p v-if="isMGMTxQueueIdSpecified" class="mt-2">
      MY.GAMES market transaction queue id<br>
      {{ mgmTxQueueId }}
    </p>
  </div>
</template>

<script>
import { getShortSKU } from '../util.js';

export default {
  name: 'PlayerPendingInfoRestorePaymentBySKU',

  props: {
    pending: {
      type: Object,
      required: true,
    }
  },

  computed: {
    shortSKU() {
      const payload = JSON.parse(this.pending.payload_json);
      return getShortSKU(payload.sku);
    },

    isMGMOrderIdSpecified() {
      return this.pending.hasOwnProperty('mgmOrderId');
    },

    mgmOrderId() {
      return this.pending.mgmOrderId;
    },

    isMGMTxQueueIdSpecified() {
      return this.pending.hasOwnProperty('mgmTxQueueId');
    },

    mgmTxQueueId() {
      return this.pending.mgmTxQueueId;
    },
  },
}
</script>
